import React, {FunctionComponent, Fragment, useContext} from 'react';
import {observer} from "mobx-react";
import {Grid, Typography} from "@material-ui/core";
import TranslatedText from "../../../ui/TranslatedText/TranslatedText";
import UITranslations from "../../../../store/uiTranslations";
import {Context} from "../../../../store/context";
import Link from "@material-ui/core/Link";

interface IOurAddressItem{}

const OurAddressItem:FunctionComponent<IOurAddressItem> = () => {
    const ui = UITranslations.GettingToPage.Wizard.Address;

    const {buildingsStore, gettingToPageStore} = useContext(Context);

    const latBuilding = buildingsStore.building?.latitude
    const lngBuilding = buildingsStore.building?.longitude
    const titleBuilding = buildingsStore.building?.address_google

    const lat = gettingToPageStore.settings?.address?.latitude ?? latBuilding
    const lng = gettingToPageStore.settings?.address?.longitude ?? lngBuilding
    const title = gettingToPageStore.settings?.address?.shortTitle ?? titleBuilding 
    const facilityName = gettingToPageStore.settings?.facilityName

    return <Fragment>
        <Typography gutterBottom>
            <TranslatedText source={ui.OurAddress}/>
        </Typography>
        {facilityName && <Typography gutterBottom>
            {facilityName}
        </Typography>}
        <Link href={`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`} underline="always">
            <Typography>{title}</Typography>
        </Link>
    </Fragment>
};

export default observer(OurAddressItem);
